/**
 * data-collapsible — Generic collapsible / accordion component
 *
 * Attributes:
 *   data-collapsible                  Wrapper element
 *   data-collapsible-toggle           Toggle trigger button
 *   data-collapsible-content          Content to show/hide
 *   data-collapsible-icon             Icon that rotates 180deg
 *   data-collapsible-group="<name>"   (optional) Accordion mode — one open per group
 */

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-collapsible-toggle]').forEach(toggle => {
        toggle.addEventListener('click', () => {
            const wrapper = toggle.closest('[data-collapsible]')
            if (!wrapper) return

            const content = wrapper.querySelector('[data-collapsible-content]')
            const icon = wrapper.querySelector('[data-collapsible-icon]')
            if (!content) return

            const isHidden = content.hasAttribute('hidden')
            const group = wrapper.getAttribute('data-collapsible-group')

            // Accordion: close others in the same group
            if (group && isHidden) {
                document.querySelectorAll(`[data-collapsible-group="${group}"]`).forEach(other => {
                    if (other === wrapper) return
                    const otherContent = other.querySelector('[data-collapsible-content]')
                    const otherIcon = other.querySelector('[data-collapsible-icon]')
                    if (otherContent) otherContent.setAttribute('hidden', '')
                    if (otherIcon) otherIcon.style.transform = ''
                })
            }

            if (isHidden) {
                content.removeAttribute('hidden')
            } else {
                content.setAttribute('hidden', '')
            }

            if (icon) {
                icon.style.transform = isHidden ? 'rotate(180deg)' : ''
            }
        })
    })
})
